import { cn } from '../../utils/cn';
import type { EventRetroOutcome } from '../../types/eventTeam';

const OUTCOME_CONFIG: Record<EventRetroOutcome, { label: string; bg: string; text: string; border: string }> = {
  success: { label: 'Success', bg: 'bg-green-500/15', text: 'text-green-300', border: 'border-green-500/25' },
  partial_success: { label: 'Partial Success', bg: 'bg-lime-500/15', text: 'text-lime-300', border: 'border-lime-500/25' },
  needs_improvement: { label: 'Needs Improvement', bg: 'bg-amber-500/15', text: 'text-amber-300', border: 'border-amber-500/25' },
  failure: { label: 'Failure', bg: 'bg-red-500/15', text: 'text-red-300', border: 'border-red-500/25' },
};

interface EventOutcomeBadgeProps {
  outcome: EventRetroOutcome | null | undefined;
  size?: 'sm' | 'md';
  className?: string;
}

export const EventOutcomeBadge = ({ outcome, size = 'sm', className }: EventOutcomeBadgeProps) => {
  if (!outcome) {
    return (
      <span
        className={cn(
          'badge badge-neutral',
          size === 'md' && 'text-xs px-2.5 py-1',
          className,
        )}
      >
        No outcome
      </span>
    );
  }
  const config = OUTCOME_CONFIG[outcome];
  return (
    <span
      className={cn(
        'badge badge-dot',
        config.bg,
        config.text,
        config.border,
        size === 'md' && 'text-xs px-2.5 py-1',
        className,
      )}
    >
      {config.label}
    </span>
  );
};
